import {
  Section,
  SectionContent,
  SectionHeader,
  useSection,
} from '@/components/Section'
import { Avatar } from '@/components/Avatar'

import styles from './ProviderSection.module.css'

export interface ProviderSectionProvider {
  displayName: string
  email: string
  avatar?: string | null
  avatarFallback?: string | null
}

export interface ProviderSectionProps {
  provider?: ProviderSectionProvider
}

export function ProviderSection({ provider }: ProviderSectionProps) {
  const sectionProps = useSection(false)

  return (
    <Section {...sectionProps}>
      <SectionHeader>Assigned Pro</SectionHeader>

      <SectionContent>
        {provider && <ProviderItem provider={provider} />}
      </SectionContent>
    </Section>
  )
}

interface ProviderItemProps {
  provider: ProviderSectionProvider
}

function ProviderItem({ provider }: ProviderItemProps) {
  return (
    <div className={styles.root}>
      <Avatar subject={provider} size={24} />
      <div className={styles.provider}>
        <div className={styles.username}>{provider.displayName}</div>
        <div className={styles.email}>{provider.email}</div>
      </div>
    </div>
  )
}
